var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { CaseAssistAntiFraudSurveyCaseService } from '~/services/domain-service/case-assist-anti-fraud-survey-case.service.ts';
import ViewAttachList from "~/components/common/view-attach-list.vue";
var SurveyRecords = /** @class */ (function (_super) {
    __extends(SurveyRecords, _super);
    function SurveyRecords() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.dialog = {
            fileList: false
        };
        _this.fileIds = "";
        return _this;
    }
    SurveyRecords.prototype.emitClose = function () { };
    SurveyRecords.prototype.onAssistIdChange = function (val) {
        var _this = this;
        this.dataSet = [];
        if (val) {
            this.caseAssistAntiFraudSurveyCaseService.getCheatDetails(val).subscribe(function (data) { return _this.dataSet = data; });
        }
    };
    SurveyRecords.prototype.formatterResult = function (row) {
        var result = this.$filter.dictConvert(row.surveyResults, 'SurveyResults');
        if (row.surveyResults === "Fraud") {
            var tmpResult1_1 = this.customDataDict.find(function (v) { return v.id === row.dataPoolId; });
            if (tmpResult1_1) {
                var tmpResult2 = this.customDataDict.find(function (v) { return v.id === tmpResult1_1.parentId; });
                if (tmpResult2) {
                    result += "/" + tmpResult2.name + "/" + tmpResult1_1.name;
                }
                else {
                    result += "/" + tmpResult1_1.name;
                }
            }
        }
        return result;
    };
    __decorate([
        Prop({ required: true })
    ], SurveyRecords.prototype, "assistId", void 0);
    __decorate([
        State
    ], SurveyRecords.prototype, "customDataDict", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudSurveyCaseService)
    ], SurveyRecords.prototype, "caseAssistAntiFraudSurveyCaseService", void 0);
    __decorate([
        Emit('close')
    ], SurveyRecords.prototype, "emitClose", null);
    __decorate([
        Watch("assistId", { immediate: true })
    ], SurveyRecords.prototype, "onAssistIdChange", null);
    SurveyRecords = __decorate([
        Component({
            components: {
                ViewAttachList: ViewAttachList
            },
        })
    ], SurveyRecords);
    return SurveyRecords;
}(Vue));
export default SurveyRecords;
